import { render, staticRenderFns } from "./featureScreening.vue?vue&type=template&id=566c2052&scoped=true&"
import script from "./featureScreening.vue?vue&type=script&lang=js&"
export * from "./featureScreening.vue?vue&type=script&lang=js&"
import style0 from "./featureScreening.vue?vue&type=style&index=0&id=566c2052&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566c2052",
  null
  
)

export default component.exports